import { render, staticRenderFns } from "./LifeskillsSection.vue?vue&type=template&id=34cb3a37&scoped=true&"
import script from "./LifeskillsSection.vue?vue&type=script&lang=js&"
export * from "./LifeskillsSection.vue?vue&type=script&lang=js&"
import style0 from "./LifeskillsSection.vue?vue&type=style&index=0&id=34cb3a37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cb3a37",
  null
  
)

export default component.exports